import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { checkDate } from "common/helpers/Date";

export const fromJSON = (json: Partial<IEstimateOverviewData>): EstimateOverviewRecord => {
  if (json.created_at) {
    json.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    json.updated_at = checkDate(json.updated_at);
  }

  return new EstimateOverviewRecord(json as any as EstimateOverviewRecord);
};

export interface IEstimateOverviewData {
  id: number;
  name: string;
  line_items_count: number;
  total: number;
  created_at?: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IEstimateOverviewRecord {
  id: Nullable<number>;
  name: Nullable<string>;
  line_items_count: Nullable<number>;
  total: Nullable<number>;
  created_at: Date;
  updated_at: Date;
}

export const defaultEstimateOverviewProps = {
  id: 0,
  name: null,
  line_items_count: 0,
  total: 0,
  created_at: new Date(),
  updated_at: new Date(),
};

export class EstimateOverviewRecord extends Record(defaultEstimateOverviewProps) implements IEstimateOverviewRecord {}

export type DocType = "estimate" | "contract" | "inspection";
